import { c as _c } from "react/compiler-runtime";
import { DigitalProductErrorInterface } from 'modules/digital-product/types/digital-product-interface';
import { ECourseTabEnum, tabLocoKeys } from 'modules/stores/store/content/product/digital-product/product-e-course/enum/e-course-tab-enum';
import { getCourseError } from 'modules/stores/store/content/product/digital-product/product-e-course/utils/get-course-error';
import { ProductECourseItemErrorsType } from 'modules/stores/store/content/product/types/product-interface';
import { getDigitalProductCheckoutErrorChecker, getOptionsErrorChecker, getThankYouErrorChecker, getThumbnailErrorChecker } from 'modules/stores/store/utils/get-error-checkers';
import { useFormErrorMessageInTabs } from 'modules/stores/store/utils/use-form-error-message-in-tabs';
export const useErrorMessageInTabs = () => {
  const $ = _c(2);
  const {
    formErrorMessage: formErrorMessageCommon
  } = useFormErrorMessageInTabs();
  const getTabsWithErrors = _temp;
  let t0;
  if ($[0] !== formErrorMessageCommon) {
    const formErrorMessage = t1 => {
      const {
        errors: errors_0,
        digitalProductErrors: digitalProductErrors_0
      } = t1;
      const tabsErrorsMap = getTabsWithErrors({
        errors: errors_0,
        digitalProductErrors: digitalProductErrors_0
      });
      return formErrorMessageCommon({
        tabsErrorsMap,
        tabsLocoKeys: tabLocoKeys
      });
    };
    t0 = {
      getTabsWithErrors,
      formErrorMessage
    };
    $[0] = formErrorMessageCommon;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
function _temp(t0) {
  const {
    errors,
    digitalProductErrors
  } = t0;
  const hasThumbnailError = getThumbnailErrorChecker(errors);
  const hasCheckoutError = getDigitalProductCheckoutErrorChecker(errors, digitalProductErrors);
  const hasThankYouError = getThankYouErrorChecker(errors);
  const hasCourseError = getCourseError(errors);
  const hasOptionsError = getOptionsErrorChecker(digitalProductErrors);
  return {
    [ECourseTabEnum.course]: hasCourseError,
    [ECourseTabEnum.options]: hasOptionsError,
    [ECourseTabEnum.thumbnail]: hasThumbnailError,
    [ECourseTabEnum.checkout]: hasCheckoutError,
    [ECourseTabEnum.thank_you]: hasThankYouError
  };
}